export default class HomeSectionModel {
  constructor(data) {
    this.sectionId = data.section_id;
    this.sectionTitle = data.section_title;
    this.keywords = data.section_keywords;
    this.sectionExhibitionType = data.section_exhibition_type;
    this.sectionIndex = data.section_index;
    this.chapter = data.section_chapters.map(chapter => {
      if (chapter.chapter_type === 'content') {
        return {
          index: chapter.chapter_index,
          type: chapter.chapter_type,
          content: {
            id: chapter.chapter_content.content_id,
            title: chapter.chapter_content.content_title,
            subtitle: chapter.chapter_content.content_subtitle,
            description: chapter.chapter_content.content_description,
            type: chapter.chapter_content.content_type,
            thumbnailUrl: chapter.chapter_content.content_thumbnail_url,
            purchaseTemplateId: chapter.chapter_content.content_template_id,
            status: chapter.chapter_content.content_is_blocked ? 'blocked' : 'available',
            url: chapter.chapter_content.content_url,
            access: chapter.chapter_content.content_access,
            additionalInfo: chapter.chapter_content.content_additional_info,
            createdAt: chapter.chapter_content.content_created_at,
            updatedAt: chapter.chapter_content.content_updated_at
          }
        };
      } else if (chapter.chapter_type === 'serie') {
        return {
          index: chapter.chapter_index,
          type: chapter.chapter_type,
          content: {
            id: chapter.chapter_serie.serie_id,
            title: chapter.chapter_serie.serie_title,
            subtitle: chapter.chapter_serie.serie_subtitle,
            description: chapter.chapter_serie.serie_description,
            type: 'serie',
            thumbnailUrl: chapter.chapter_serie.serie_thumbnail_url,
            purchaseTemplateId: chapter.chapter_serie.serie_template_id,
            status: chapter.chapter_serie.serie_is_blocked ? 'blocked' : 'available',
            access: chapter.chapter_serie.serie_access
          }
        };
      }
      return null;
    }).filter(Boolean);
  }
}
